import { useStore } from '@nanostores/react';
import { atom } from 'nanostores';
import { useEffect, type ReactNode } from 'react';

import { ThemeContext, type ThemeContextValue } from './useTheme';

type Theme = 'light' | 'dark';

const themeStore = atom<Theme>('dark');

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useStore(themeStore);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
  }, [theme]);

  const setTheme = (newTheme: Theme) => {
    themeStore.set(newTheme);
  };

  const value: ThemeContextValue = {
    theme,
    resolvedTheme: theme,
    setTheme,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
